function showBYOM() {
	var purchaseModem = document.getElementById("purchase-modem-section");
	var byom = document.getElementById("byom-section");

	purchaseModem.style.display = "none";
	byom.style.display = "block";
}

function showModems() {
	var purchaseModem = document.getElementById("purchase-modem-section");
	var byom = document.getElementById("byom-section");

	purchaseModem.style.display = "block";
	byom.style.display = "none";
}

function HardwareViewModel() {
	var self = this;

	self.isLoading = ko.observable(true);

	self.lang = ko.observable(null);
	self.generalDescription = ko.observable(null);
	self.packageName = ko.observable(null);

	self.serviceStatus = ko.observable(null);
	self.isAuto = ko.observable(false);
	self.isManual = ko.observable(false);
	self.isRestricted = ko.observable(false);

	self.download = ko.observable(null);
	self.upload = ko.observable(null);
	self.bandwidth = ko.observable(null);

	self.regularPrice = ko.observable(null);
	self.installationFee = ko.observable(null);
	self.promoAvailable = ko.observable(false);
	self.price = ko.observable(null);
	self.priceDollars = ko.observable(null);
	self.priceCents = ko.observable(null);
	self.costInterval = ko.observable(null);

	self.urlStorefront = ko.observable(null);
	self.connectedDevices = ko.observable(null);

	self.showOfferDetails = function () {
		var dlg = document.getElementById("pkg-legal-modal");
		if (!dlg) return;
		dlg.showModal();
	};

	var query = parseQuery(document.location.search);
	if (!query.prov || !query.itemID) return;

	var matched = null;
	var itemID = parseInt(query.itemID, 10);
	var json = window.sessionStorage.getItem(KEY_INTERNET_SERVICE);
	var allPackages = JSON.parse(json);

	if (!allPackages || allPackages.length === 0) return;
	for (var s = 0; s < allPackages.length; s++) {
		var service = allPackages[s];
		var groupedBySpeed = service.groupedBySpeed;
		for (var g = 0; g < groupedBySpeed.length; g++) {
			var group = groupedBySpeed[g];
			var packages = group.items;
			for (var p = 0; p < packages.length; p++) {
				var item = packages[p];
				if (item.itemID !== itemID) continue;
				var serviceStatus = service.serviceStatus;
				matched = {}; // just need a non-null result
				var lang = document.documentElement.lang || "en";
				var details = document.getElementById("internet-hardware-detailed-description");
				if (details) {
					details.innerHTML = group.detailedDescription[lang];
				}

				self.lang(lang);
				self.generalDescription(group.generalDescription[lang]);
				self.packageName(item.name[lang]);

				self.serviceStatus(serviceStatus);
				self.isAuto(serviceStatus === "AUTO");
				self.isManual(serviceStatus === "MANUAL");
				self.isRestricted(serviceStatus === "RESTRICTED");

				self.download(group.download);
				self.upload(group.upload);
				self.bandwidth(item.bandwidth);

				var price = group.promoAvailable ? item.promotionPrice : item.price;
				self.price(price);
				self.regularPrice(showRegularPrice(item.price));
				self.costInterval(group.costInterval[lang]);
				self.promoAvailable(group.promoAvailable);

				var installationFee = parseInt(group.oneTimeActivationCost) > 0
				self.installationFee(installationFee);

				var strPrice = price.toFixed(2);
				var nums = strPrice.split(".");

				self.priceDollars(showPackageDollars(nums[0]));
				self.priceCents(showPackageCents(nums[1]));
			
				var jsonAddr = window.sessionStorage.getItem(KEY_INTERNET_SERVICE);
				var addr = JSON.parse(jsonAddr);
				var qStore = serialize({ itemID: item.itemID, globalAddressId: addr.globalAddressId });
				self.urlStorefront(qStore);

				var connectedDevices = "t.b.a.";
				var download = parseInt(group.download);
				if (download >= 1000) {
					connectedDevices = "200+";
				} else if (download >= 120) {
					connectedDevices = "10+";
				} else if (download >= 40) {
					connectedDevices = "5-9";
				} else if (download >= 15) {
					connectedDevices = "5-9";
				} else if (download >= 6) {
					connectedDevices = "1-4";
				} else {
					connectedDevices = "1-4";
				}

				self.connectedDevices(connectedDevices);

				break;
			}
			if (matched) break;
		}
		if (matched) break;
	}
}

addLoadEvent(function () {
	if (HARDWARE_NODE && typeof HARDWARE_NODE !== "undefined") {
		window.hardwareApp = new HardwareViewModel();
		ko.applyBindings(window.hardwareApp, HARDWARE_NODE);
		window.hardwareApp.isLoading(false);
	}
});
